<template>
    <div>
        <Head :title="title" />

        <div class="flex justify-center my-2">
            <img src="/images/logo.png" style="max-height: 60px;" alt="Logo" class="logo">
        </div>

        <jet-banner />

        <div class="lg:flex">
            <div class="flex-1">
                <main>
                    <slot></slot>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import JetApplicationMark from '@/Jetstream/ApplicationMark.vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import JetBanner from '@/Jetstream/Banner';

    export default {
        props: {
            title: String,
        },

        components: {
            Head,
            JetBanner,
            JetApplicationMark,
        },
    }
</script>

<style>
#sidebar-primary {
    z-index: 50;
}
body {
    @apply text-gray-darker;
    font-size: 16px;
}

@media screen and (min-width: 1024px) {
    .sidebar {
        width: 240px;
    }

    .content {
        padding-left: 240px;
    }

    .no-sidebar #sidebar-primary {
        @apply hidden;
    }

    .no-sidebar .content {
        padding-left: 0;
    }
}

h1 {
    @apply text-3xl font-bold;
}

h2 {
    @apply text-2xl font-bold;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

textarea,
input[type=text],
input[type=email],
input[type=date],
input[type=datetime],
input[type=checkbox],
input[type=password],
input[type=search],
input[type=tel],
input[type=time],
input[type=url],
input[type=number] {
    @apply py-1 border border-gray focus:border-gray focus:outline-none focus:ring-green;
}

input[type=checkbox] {
    @apply text-green;
}

select {
    @apply pl-2 py-1 pr-8 border border-gray ring-green rounded;
}

textarea:disabled,
select:disabled,
input:disabled {
    @apply bg-gray-200 cursor-not-allowed;
}

input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    @apply text-gray-400;
}
input::-moz-placeholder { /* Firefox 19+ */
    @apply text-gray-400;
}
input:-ms-input-placeholder { /* IE 10+ */
    @apply text-gray-400;
}
input:-moz-placeholder { /* Firefox 18- */
    @apply text-gray-400;
}

textarea::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    @apply text-gray-400;
}
textarea::-moz-placeholder { /* Firefox 19+ */
    @apply text-gray-400;
}
textarea:-ms-input-placeholder { /* IE 10+ */
    @apply text-gray-400;
}
textarea:-moz-placeholder { /* Firefox 18- */
    @apply text-gray-400;
}

textarea {
    @apply rounded;
}

button {
    @apply border border-gray bg-gray-light px-3 py-1 font-bold focus:outline-none focus:ring-green focus:ring-1 hover:bg-gray;
}

.button-group {
    @apply flex;
}

.button-group button,
.button-group input {
    @apply relative focus:z-50;
}

.button-group button:first-child {
    @apply rounded-tl rounded-bl border-r-0;
}

.button-group button:last-child {
    @apply rounded-tr rounded-br border-l-0;
}

.button-group select {
    @apply py-1 bg-gray-light border border-r-0 border-gray rounded-tl rounded-bl focus:ring-green focus:ring-opacity-50 focus:outline-none focus:border-gray focus:z-50 relative cursor-pointer;
}

input.quantity {
    max-width: 60px;
}

input.price {
    @apply py-0 px-1 text-right;
    max-width: 65px;
}

@media screen and (min-width: 768px) {
    input.quantity {
        max-width: 65px;
    }
    input.price {
        max-width: 75px;
    }
}

td input.quantity,
input.notes {
    @apply py-0 px-1;
}

.form-group {
    @apply my-6;
}

.striped {
    @apply even:bg-gray-lighter;
    @apply odd:bg-white;
}

.toggle {
    --toggle-bg-on: #85C71E;
    --toggle-border-on: #85C71E;
}

/* TODO: look into importing the multiselect CSS globally and removing the !important class */
/* TODO: Focus ring width variance is due to the :searchable prop on multiselect...troubleshoot that */
.multi-sm {
    min-height: 1.5rem !important;
}

@media screen and (min-width: 768px) {
    .multi-sm {
        min-width: 7rem;
    }
}

@media screen and (min-width: 1280px) {
    .multi-sm {
        min-width: 10rem;
    }
}

.multi-lg {
    min-height: 2.1rem !important;
}

.multiselect, .multiselect-search {
    @apply focus:ring-green focus:ring-1;
    --ms-option-bg-selected: #85C71E;
}

.multiselect-options, .multiselect-dropdown {
    max-height: 20rem !important;
}

.is-active {
    @apply shadow-none !important;
}

.table tr {
    @apply even:bg-gray-lighter odd:bg-white;
}

.table th {
    @apply bg-gray-light border-b px-2 py-1 leading-tight h-10 text-sm align-bottom;
}

.table td {
    @apply px-2 py-1 border-b;
}

.table td button {
    @apply leading-tight py-1 px-3 align-middle;
}

.table.table-with-links td {
    @apply p-0;
}
</style>
